// src/components/UI/loadingSpinner/buttonLoader.tsx
import React from "react";
import classes from "./buttonLoader.module.scss"; // Assuming your spinner styles are here

const buttonLoader = () => {
  return (
    <div className={classes.spinner}></div>
  );
};

export default buttonLoader;